<app-common-form [loading]="isSubmitting" [initialData]="currentWorkspace" (save)="onSubmit($event)"> </app-common-form>
